<template>
    <rkm-overlay>
        <rkm-layout-body title="Estorno de dispensação de medicamento">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/farmacia/estorno-dispensacao/List'

export default {
    components: { List },
}
</script>